<div class="container">
    <!-- Modal for rendering the charts -->
    <div id="modal1" class="modal">
        <canvas id="modal-chart"></canvas>
    </div>

    <!-- Chatbot widget -->

    <div class="widget" #widget [@expandContent]="store.isExpandedForComplexContent() ? 'expanded' : 'normal'"  *ngIf="store.isShowChat(); else chatClosedProfile">
        <div class="chat_header ToolsAiHeadertooltip"
             #ToolsAiHeadertooltip="matTooltip"
             [matTooltip]="message_header_widget"
             [matTooltipClass]="'tools-ai-error-tooltip'"
             matTooltipPosition="below">
            <!-- Avatar do bot baseado no estado -->
            <ng-container *ngIf="store.isRecording(); else elseBlock1">
                <img alt="Avatar" class="chat-avatar"
                     src="assets/llm_resources/img/robot_v1/robot_tecinco_escuchando_sin_fondo.png">
            </ng-container>
            <ng-template #elseBlock1>
                <ng-container *ngIf="store.isUserTypingText(); else elseBlock2">
                    <img alt="Avatar" class="chat-avatar"
                         src="assets/llm_resources/img/robot_v1/robot_tecinco_mirando_atencion.png">
                </ng-container>
                <ng-template #elseBlock2>
                    <ng-container *ngIf="store.isSpeaking(); else elseBlock3">
                        <img alt="Avatar" class="chat-avatar"
                             src="assets/llm_resources/img/robot_v1/robot_tecinco_falando_sin_fondo.png">
                    </ng-container>
                    <ng-template #elseBlock3>
                        <img alt="Avatar" class="chat-avatar"
                             src="assets/llm_resources/img/robot_v1/Design-ohne-Titel-8.png">
                    </ng-template>
                </ng-template>
            </ng-template>

            <span class="chat_header_title">GlorIA</span>


            <!-- Controles de bate-papo -->
            <button class="dropdown-trigger" mat-icon-button (click)="store.toggleShowChat()"
                    matTooltipPosition="above" matTooltip="Fechar a janela de bate-papo">
                <mat-icon>close</mat-icon>
            </button>

            @if(!store.isExpandedForComplexContent()){
                <button class="dropdown-trigger" mat-icon-button  (click)="expandChatForContent()"
                        matTooltipPosition="above" matTooltip="Expande a janela de bate-papo">
                    <mat-icon>unfold_more</mat-icon>
                </button>
            }@else{
            <button class="dropdown-trigger" mat-icon-button  (click)="collapseChatAfterContent()"
                        matTooltipPosition="above" matTooltip="Collapse a janela de bate-papo">
                    <mat-icon>unfold_less</mat-icon>
                </button>
            }

            <!--      <button class="dropdown-trigger" mat-icon-button (click)="toolsAiDialogsService.openSettingsAiDialog()"-->
            <!--              matTooltipPosition="above" matTooltip="Configuraçoes de GlorIA">-->
            <!--        <mat-icon>dashboard_customize</mat-icon>-->
            <!--      </button>-->
            <div class="dropdown-trigger"
                 matTooltipPosition="above"
                 [matTooltip]="chatUIService.tooltipDoBotaoDeConfiguracoes">
                <button id="button-settings" mat-icon-button (click)="toolsAiDialogsService.openSettingsAiDialog()"
                        [disabled]="!state.isHabilitedButtonSettings()">
                    <mat-icon>dashboard_customize</mat-icon>
                </button>
            </div>


            <button style="display:none" class="dropdown-trigger dropdown-trigger-visual" mat-icon-button
                    (click)="clearChat()" matTooltipPosition="above" matTooltip="Limpar mensagens do bate-papo">
                <mat-icon>delete_outline</mat-icon>
            </button>
            <button style="display:none" class="dropdown-trigger dropdown-trigger-visual" mat-icon-button
                    (click)="restartChat()" matTooltipPosition="above" matTooltip="Reiniciar a conversa">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>

        <div class="chats" id="chats" #chats></div>

        <!-- Input area -->
        <div class="keypad d-flex flex-nowrap">
            <ng-container *ngIf="store.isRecording(); else userInputArea">
                <div class="sound-wave">
                    <ng-container *ngFor="let i of [].constructor(48); let index = index">
                        <span></span>
                    </ng-container>
                </div>
            </ng-container>

            <ng-template #userInputArea>
        <textarea #text_area_user_input id="userText" placeholder="Digite uma mensagem..."
                  class="usrInput" [disabled]="store.isRecording()"
                  (keydown.enter)="sendMessage($event)"
                  (ngModelChange)="onUserTextInput()"
                  [(ngModel)]="userText"></textarea>
            </ng-template>


            <button #sendButton
                    id="sendButton"
                    (click)="handleInteractionButtonClick()"
                    [disabled]="store.isSpeaking() || store.isProcessingAudio() || store.isProcessingText()">
                <ng-container *ngIf="store.isRecording(); else elseBlock4">
                    <mat-icon>stop</mat-icon>
                </ng-container>
                <ng-template #elseBlock4>
                    <ng-container *ngIf="state.showMicrophoneIcon(); else elseBlock5">
                        <mat-icon id="llm-microphoneIcon" matTooltip="Use microphone">mic</mat-icon>
                    </ng-container>
                    <ng-template #elseBlock5>
                        <ng-container
                                *ngIf="!store.isMicrophoneAccessGranted() && store.settingsToolsAi().voiceInteractionEnabled && !store.isUserTypingText(); else elseBlock6">
                            <mat-icon>mic_off
                            </mat-icon>
                        </ng-container>
                        <ng-template #elseBlock6>
                            <ng-container *ngIf="state.showSendButton()">
                                <mat-icon>send</mat-icon>
                            </ng-container>
                        </ng-template>
                    </ng-template>
                </ng-template>
            </button>
        </div>
    </div>

    <ng-template #chatClosedProfile>
        <!-- Perfil do bot quando o bate-papo está fechado -->
        <div class="profile_div" id="profile_div" #profileDiv
             cdkDrag
             cdkDragBoundary="body"
             (cdkDragEnded)="onProfileDragEnded($event)"
             [style.top.px]="profilePosition()?.top ?? null"
             [style.left.px]="profilePosition()?.left ?? null"
             [style.right]="profilePosition() ? 'auto' : null"
             [style.bottom]="profilePosition() ? 'auto' : null"
             (click)="store.toggleShowChat()">
            <img #imgAnimated class="imgProfile" alt="Robô animado"
                 src="assets/llm_resources/img/animated/Robot3DAnimated.gif"/>
            <img #imgStatic style="display:none" class="imgProfile" alt="Robô estático"
                 src="assets/llm_resources/img/robot_v1/Design-ohne-Titel-8.png"/>
        </div>
    </ng-template>

</div>
